module.exports = __webpack_public_path__ + "img/new.24a28c9b.png";